<!-- 由 suu 创建于 2025-03-04 星期二 -->
<template>
  <div class="DetailPop">
    <!-- 约课确认 -->
    <div class="appoconf-wrap">
      <div class="wrap-title">您确定要预约该课程吗？</div>
      <div class="wrap-sub"
        >距离上课时间还有<span class="sub-time">{{ popObj.popText }}</span></div
      >
      <div class="wrap-desc">
        <div class="desc-top">
          <img
            src="https://cdnvue.gymcity.com.cn/uploads/25coach-confirm-coach-bg?v=1"
            alt=""
            class="desc-bg"
          />
          <div class="top-left">
            <div class="left-title">带训教练</div>
            <div class="left-name"
              >{{ detailData.name.slice(0, 6)
              }}{{ detailData.name.length > 6 ? '..' : '' }}</div
            >
            <div
              class="left-sub"
              v-if="showInfo && showInfo.tag_list && showInfo.tag_list.length"
            >
              <span v-for="(item, index) in showInfo.tag_list" :key="index">
                {{ item.tag_name }}{{ index > 1 ? '\n' : ''
                }}<span
                  class="sub-icon"
                  v-if="index < showInfo.tag_list.length - 1"
                >
                  /
                </span>
              </span>
            </div>
            <div class="left-character" v-if="tagName2">
              <span class="ittc-label">训练风格</span>
              <van-icon class="ittc-star" name="star" />
              <span class="ittc-value"> {{ tagName2 }}</span>
            </div>
          </div>
          <img
            class="top-coach-img"
            :src="
              showInfo.app_img +
              '??x-oss-process=image/resize,m_fill,h_400,w_400'
            "
            alt=""
          />
          <img
            src="https://cdnvue.gymcity.com.cn/uploads/25coach-confirm-coach-ov"
            alt=""
            class="top-coach-ov"
          />
        </div>
        <div class="desc-other">
          <div class="other-item">
            <div class="item-title"
              ><img
                class="title-icon"
                src="https://cdnvue.gymcity.com.cn/uploads/25coach-appo-icon-time"
                alt=""
              />预约时间</div
            >
            <div class="item-date">
              {{ popObj.obj.coursestarttime.slice(11, 16) }} -
              {{ popObj.obj.courseendtime.slice(11, 16) }}</div
            >
            <div class="item-sub">{{
              popObj.obj.coursestarttime.split(' ')[0].replace(/-/g, '.')
            }}</div>
          </div>
          <div class="other-line"></div>
          <div class="other-item other-item-2" @click="handleOpenMap">
            <div class="item-title"
              ><img
                class="title-icon"
                src="https://cdnvue.gymcity.com.cn/uploads/25coach-appo-icon-location"
                alt=""
              />训练场馆</div
            >
            <div class="item-date"> {{ detailData.shop_name }}</div>
            <!-- distanceP 步行  distance 车程 -->
            <div class="item-sub" v-if="popObj.distanceP || popObj.distance">
              {{ popObj.distanceP || popObj.distance }}</div
            >
            <div class="item-sub user-btn" v-else>查看场馆具体位置 ></div>
          </div>
        </div>

        <!-- 拍照教练勾选 -->
        <template v-if="detailData.is_photo == 1">
          <div class="check-region">
            <div class="check-desc">
              <div class="check-title">我需要教练为我拍健身美照</div>
              <div class="check-sub">勾选后，教练会收到您的拍照需求哟</div>
            </div>
            <van-checkbox
              class="check-radio"
              v-model="checkPhoto"
              @change="handleCheckChange"
              checked-color="#050B27"
              icon-size="20"
            ></van-checkbox>
          </div>
        </template>
      </div>
      <div class="wrap-btns">
        <div class="btn-1 user-btn" @click="handleCancel">取消</div>
        <div class="btn-2 user-btn" @click="handleConfirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailPop',

  components: {},

  props: {
    detailData: {},
    showInfo: {},
    appointConfirmation: {},
    popObj: {}
  },

  data() {
    return {
      checkPhoto: false
    }
  },

  computed: {
    tagName2() {
      if (!this.showInfo) {
        return ''
      }
      const tag_list2 = this.showInfo.tag_list2 || []
      if (tag_list2.length > 0) {
        return tag_list2
          .map((item) => {
            return item.tag_name
          })
          .join('/')
      }
      return ''
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 拍照切换
    handleCheckChange() {
      this.$emit('checkChange', this.checkPhoto)
    },
    // 确认预约
    handleConfirm() {
      this.$emit('confirm')
    },
    // 取消预约
    handleCancel() {
      this.$emit('cancel')
    },
    // 打开地图
    handleOpenMap() {
      this.$betterwe.jumpRoute(
        `/mapLauncher?latitude=${parseFloat(
          this.showInfo.lat
        )}&longitude=${parseFloat(this.showInfo.lon)}&title=${
          this.showInfo.shop_name
        }`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailPop {
  height: max-content;
  .appoconf-wrap {
    width: 100%;
    box-sizing: border-box;
    background: #f9f9f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: vw(36);
    .wrap-title {
      width: 100%;
      box-sizing: border-box;
      padding: 0 vw(20);
      margin-top: vw(26);
      font-weight: 600;
      font-size: 22px;
      color: #050b27;
      line-height: 30px;
    }
    .wrap-sub {
      width: 100%;
      box-sizing: border-box;
      margin-top: vw(5);
      padding: 0 vw(20);
      font-weight: 300;
      font-size: 14px;
      color: #050b27;
      line-height: 20px;
      display: flex;
      align-items: center;
      .sub-time {
        font-weight: 600;
        margin-left: vw(4);
      }
    }
    .wrap-desc {
      width: 355px;
      // height: 289px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;
      margin-top: vw(10);
      padding: vw(10);
      padding-bottom: vw(17);
      display: flex;
      flex-direction: column;
      align-items: center;

      .desc-top {
        width: 335px;
        height: 160px;
        box-sizing: border-box;
        padding-top: 16px;
        padding-left: 20px;
        border-radius: 8px;
        position: relative;
        z-index: 1;
        .desc-bg {
          width: 100%;
          height: 160px;
          box-sizing: border-box;
          position: absolute;
          top: 0px;
          left: 0px;
          z-index: -1;
        }
        .top-left {
          .left-title {
            font-weight: 600;
            font-size: 12px;
            color: rgba($color: #050b27, $alpha: 0.5);
            line-height: 17px;
          }
          .left-name {
            font-weight: 600;
            font-size: 25px;
            color: #050b27;
            line-height: 33px;
            margin-top: 8px;
          }
          .left-sub {
            margin-top: 3px;
            font-weight: 300;
            font-size: 10px;
            color: #050b27;
            line-height: 16px;
            white-space: pre-line;
          }
          .left-character {
            width: 154px;
            height: 24px;
            box-sizing: border-box;
            background: #ffedd3;
            border-radius: 4px;
            padding-left: 11px;
            display: flex;
            align-items: center;
            position: absolute;
            bottom: 16px;
            left: 20px;
            z-index: 1;
            .ittc-label {
              font-weight: 400;
              font-size: 12px;
              color: #704b1b;
            }
            .ittc-star {
              color: #d0a76e;
              margin-left: 5px;
              margin-right: 4px;
            }
            .ittc-value {
              font-weight: 600;
              font-size: 12px;
              color: #704b1b;
            }
          }
        }
        .top-coach-img {
          width: 160px;
          height: 160px;
          position: absolute;
          top: 0px;
          right: 0px;
        }
        .top-coach-ov {
          width: auto;
          height: 160px;
          box-sizing: border-box;
          position: absolute;
          top: 0px;
          left: 175px;
          z-index: 0;
        }
      }

      .desc-other {
        width: 100%;
        box-sizing: border-box;
        margin-top: 17px;
        padding-left: 20px;
        display: flex;
        .other-item {
          display: flex;
          flex-direction: column;
          &.other-item-2 {
            width: 168px;
          }
          .item-title {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 12px;
            line-height: 17px;
            color: rgba($color: #050b27, $alpha: 0.8);
            line-height: 17px;
            .title-icon {
              width: 15px;
              opacity: 0.6;
              margin-right: 5px;
            }
          }
          .item-date {
            margin-top: 8px;
            font-weight: 600;
            font-size: 15px;
            color: #050b27;
            line-height: 21px;
          }
          .item-sub {
            font-weight: 300;
            font-size: 10px;
            color: #050b27;
            line-height: 14px;
            margin-top: 1px;
          }
        }
        .other-line {
          width: 1px;
          height: 60px;
          margin-left: 24px;
          margin-right: 20px;
          background-image: radial-gradient(
            circle at center,
            #050b27 0.5px,
            transparent 0.5px
          );
          background-size: 1px 5px;
          background-repeat: repeat-y;
        }
      }
      .check-region {
        width: vw(335);
        height: vw(48);
        box-sizing: border-box;
        padding: 0 vw(20);
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f7f7f7;
        border-radius: 4px;
        margin-top: vw(20);
        margin-bottom: vw(-7);
        .check-desc {
          .check-title {
            font-weight: 600;
            font-size: 13px;
            color: #050b27;
            line-height: 18px;
          }
          .check-sub {
            font-weight: 400;
            font-size: 10px;
            color: rgba($color: #050b27, $alpha: 0.8);
            line-height: 14px;
          }
        }
      }
    }
    .wrap-btns {
      width: vw(355);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: vw(20);
      .user-btn:active {
        transform: scale(0.95);
      }
      .btn-1 {
        width: 130px;
        height: 44px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
        font-size: 18px;
        color: #050b27;
        line-height: 22px;
      }
      .btn-2 {
        width: 220px;
        height: 44px;
        box-sizing: border-box;
        background: #ff2270;
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        line-height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
